"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLoading = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _button = require("./button");
var _spinner = require("./spinner/spinner");
var _excluded = ["isLoading", "loadingText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ButtonLoading = exports.ButtonLoading = function ButtonLoading(props) {
  var isLoading = props.isLoading,
    loadingText = props.loadingText,
    buttonProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _buttonProps = _objectSpread({}, buttonProps),
    children = _buttonProps.children,
    _buttonProps$size = _buttonProps.size,
    size = _buttonProps$size === void 0 ? 'md' : _buttonProps$size;
  return /*#__PURE__*/_react["default"].createElement(_button.Button, buttonProps, isLoading ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "btn-loading__container"
  }, /*#__PURE__*/_react["default"].createElement(_spinner.Spinner, {
    size: size
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "btn-loading__text"
  }, loadingText == null ? children : loadingText)) : children);
};

// is only needed to avoid snapshots updating
ButtonLoading.defaultProps = {
  loadingText: null
};